import { classNames } from "primereact/utils";
import { dateUtility } from "../../../../infrastructure/utilities/dateUtility";
import { INoteViewModel } from "../models/noteModel";
import styles from "./Note.module.scss";
import { showCustomConfirmDialog } from "../../../dialogs/AppConfirmDialog";

interface INotesProps {
  note: INoteViewModel;
  onEditClick: (noteId: number) => void;
  onDelete: (noteId: number) => void;
}

export const Note = ({ note, onEditClick, onDelete }: INotesProps) => {
  const onTryDeleteConfirm = () => {
    showCustomConfirmDialog(
      "Сигурни ли сте че искате да изтриете тази бележка?",
      () => onDelete(note.id),
      () => {},
      "warning",
      "Да",
      "Не"
    );
  };

  return (
    <div className={styles.note_item}>
      <div className={styles.note_header}>
        <div className={styles.note_info}>
          <span className={styles.note_author}>{note.createdBy}</span>
          <span className={styles.note_date}>
            {dateUtility.formatDateTime(note.createdOn)}
          </span>
        </div>
        <div className={styles.note_actions}>
          <button
            className={classNames(styles.note_btn, styles.note_edit)}
            title="Редактирай бележката"
            onClick={() => onEditClick(note.id)}
          >
            <svg
              width="14"
              height="14"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              />
            </svg>
          </button>
          <button
            className={classNames(styles.note_btn, styles.note_delete)}
            title="Изтрий бележката"
            onClick={onTryDeleteConfirm}
          >
            <svg
              width="14"
              height="14"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className={styles.note_text}>{note.content}</div>
    </div>
  );
};
